import { getLinkProps } from '@/app/lib';
import Link from 'next/link';
import { Picture, Typography } from '@workspace/ui/common';
import type { IHeaderData } from '../interfaces';

interface HeaderLogoProps {
  headerData?: IHeaderData | null;
}

export const Logo = ({ headerData }: HeaderLogoProps) => {
  if (!headerData?.headerLogo) return null;
  const { headerLogo } = headerData;

  const linkProps = getLinkProps(headerLogo.link);
  const logoAlt = headerLogo.bynderLogo?.alt || headerLogo.title || 'Logo';

  if (!linkProps.href) {
    return null;
  }

  return (
    <Link {...linkProps} className="flex items-center mr-25">
      {headerLogo.bynderLogo ? (
        <div className="relative header-logo">
          <Picture
            image={headerLogo.bynderLogo}
            alt={logoAlt}
            desktopWidth={210}
            desktopHeight={50}
            className="cursor-pointer"
            fill
            priority={true}
          />
        </div>
      ) : (
        <Typography variant="h6" as="h1" className="text-primary-500 font-bold">
          {headerLogo.title}
        </Typography>
      )}
    </Link>
  );
};
